import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import { Loader, Titlesecond, fetchData} from "../General";
import {Helmet} from "react-helmet";

const Promo = (props) => {
    let { global }=props
    const [content, setContent] = useState(null)

    useEffect( () => {
        fetchData(`${global.domain}api-portal/content/view.json?id=53`, setContent)
    },[])
    
    return <>
        {content !== null ?
        <div className={'bg-white border-bottom-yellow'}>
            <Helmet>
                <title>{`${content.content.title} - Vimenca Western Union`}</title>
                <meta name="description" content={content.content.metadescription} />
                <meta name="keywords" content={content.content.metakeywords} />
            </Helmet>
            <div className={'mainimg border-bottom'}>
                <img className={'w-100'} alt={content.content.title} src={global.domain+'/'+content.content.panoimg} />
            </div>
            <div className={'container p-5'}>
                <Row>
                <Col>
                    </Col>
                    <Col xs={12} md={4}>
                        <a href={'/faqs?id=12'} className={'py-2 px-4 float-md-right btn btn-primary'} >Preguntas Frecuentes</a>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={'mt-4'} dangerouslySetInnerHTML={{__html:content.content.content}}></div>
                    </Col>
                </Row>
            </div>
        </div>
        : <Loader />
        }
        </>

}

export default Promo;
